import { useEffect } from "react"
import { DadosContainerDefault } from "../../components/Styles"
import Dfc from "../../components/Dfc"

function DrePage () {

    useEffect (() => {
        document.title = 'Demostração do  Fluxo de Caixa | Gesttor'
    }, [])


    return (
        <DadosContainerDefault>
            <Dfc />
        </DadosContainerDefault>
    )
}

export default DrePage